import React, { Component } from 'react'
import styled from 'styled-components'
import { FlexWrapper, XXLText, StyledImage } from './'
import Icon from './Icon'
import Cookies from 'js-cookie'
import { DOWNLOAD_URL } from '../constants'
import { Circle, TextOverflow } from './StyledComponents'

const Flex = styled(FlexWrapper)`
  position: fixed;
  top: 0;
  z-index: ${props => (props.zIndex ? props.zIndex : 99999999)};
  height: 60px;
  max-width: 768px;
  justify-content: space-between;
  /* & > div:first-child {
    width: 30px;
    margin-right: 20px;
  } */
  /* & > div:nth-child(2) {
      width: calc(100% - 80px);
    }
    & > div:nth-child(3) {
      width: 30px;
    } */
`

const LeftWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  /* margin-right: 20px; */
`
const FilteredImage = styled.img`
  width: 44px;
  height: 44px;
  position: absolute;
  right: 16px;
  top: 8px;
  -webkit-filter: blur(4px); /* Safari 6.0 - 9.0 */
  filter: blur(4px);
  border-radius: 50%;
`
const ImageWrap = styled.div`
  border-radius: 50%;
  min-width: 44px;
  height: 44px;
  // border: 1px solid #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #fff;
  & > img:nth-child(2) {
    max-width: 44px;
    height: 100%;
    width: auto;
    object-fit: cover;
    border-radius: 0;
    margin: 0 auto;
    position: relative;
  }
`
class Header extends Component {
  state = {}
  render() {
    const {
      onClickBack,
      onClickEdit,
      onClickDelete,
      leftIcon,
      icon,
      title,
      showProfile,
      color,
      backgroundColor,
      onClickProfile,
      showEdit,
      onClickLeft,
      zIndex,
      ...props
    } = this.props
    return (
      <Flex
        {...props}
        zIndex={zIndex}
        viewPadding={title ? '8px 16px ' : '50px 30px 0'}
        direction="row"
        alignItems="center"
        backgroundColor={backgroundColor || '#078489'}>
        {icon && (
          <FlexWrapper direction="row" alignItems="center" width="30px" viewMargin="0 20px 0 0">
            <LeftWrap onClick={() => (onClickBack ? onClickBack() : null)}>
              <Icon icon={icon} color={color} />
            </LeftWrap>
          </FlexWrapper>
        )}
        {/* center */}
        <FlexWrapper
          alignItems={icon ? 'flex-start' : showProfile ? 'flex-start' : 'center'}
          width={showProfile ? 'calc(100% - 94px)' : 'calc(100% - 80px)'}>
          {showEdit ? (
            <FlexWrapper direction="row" alignItems="center">
              <XXLText textAlign={showProfile && 'left'} font="Chivo" color="#fff">
                <TextOverflow maxWidth="200px">{title}</TextOverflow>
              </XXLText>
              <Circle size="24px" margin="0 0 0 10px" onClick={() => (onClickEdit ? onClickEdit() : null)}>
                <Icon icon="edit" color="#078489" />
              </Circle>
            </FlexWrapper>
          ) : (
            <XXLText textAlign={showProfile && 'left'} font="Chivo" color="#fff">
              <TextOverflow maxWidth="200px">{title}</TextOverflow>
            </XXLText>
          )}
        </FlexWrapper>

        <FlexWrapper
          direction="row"
          alignItems="center"
          justifyContent={icon && 'flex-end'}
          width="44px"
          minWidth="44px">
          {showEdit ? (
            <span onClick={() => (onClickDelete ? onClickDelete() : null)}>
              <Icon icon="trash" />
            </span>
          ) : (
            <div />
          )}

          {showProfile ? (
            <ImageWrap onClick={() => (onClickProfile ? onClickProfile() : null)}>
              {Cookies.getJSON('userDetails').profileImage !== null && (
                <FilteredImage
                  src={
                    Cookies.getJSON('userDetails').profileImage
                      ? `${DOWNLOAD_URL}/${Cookies.getJSON('userDetails').profileImage}`
                      : require('../static/svgs/user.svg')
                  }
                  alt="profile_img"
                />
              )}
              <StyledImage
                height="30px"
                src={
                  Cookies.getJSON('userDetails').profileImage
                    ? `${DOWNLOAD_URL}/${Cookies.getJSON('userDetails').profileImage}`
                    : require('../static/svgs/user.svg')
                }
                alt="profile_img"
              />
            </ImageWrap>
          ) : (
            <div />
          )}
          {leftIcon ? (
            <LeftWrap onClick={() => (onClickLeft ? onClickLeft() : null)}>
              <Icon icon={leftIcon} color={'#fff'} />
            </LeftWrap>
          ) : (
            <div />
          )}
        </FlexWrapper>
      </Flex>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header.js